import { css } from 'lit';
import { fsDesignToken } from '../../core/style-util.js';

export const style = css`
  .banner-container {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow-x: hidden;
    padding-block: 0.5rem;
    position: relative;
  }

  .confetti-container {
    display: flex;
    gap: 75%;
    justify-content: center;
    max-width: calc(34rem);
    position: absolute;
    top: 0;
    width: 100%;
    z-index: -1;
  }

  .confetti-container img {
    height: 90px;
  }

  .headline-text {
    padding: 0 ${fsDesignToken('fsSizeSpacingMedium2')};
    text-align: center;
  }
`;
